import { Component, OnInit, Renderer2 } from '@angular/core'
import { AuthService, NotificationService } from '@dot-it/jml-lib'
import { Router } from '@angular/router'
import { AuthFacadeService } from '@dot-it/jml-lib'
import { DialogService } from 'primeng/dynamicdialog'
import { Md5 } from 'ts-md5'
import { BuildInfoDialogComponent } from '@dot-it/jml-lib'
import { NavSupportService } from 'projects/jml-lib/src/lib/modules/app-menu/services/nav-support.service'
import { DialogCleanupService } from 'projects/jml-lib/src/lib/services/dialog-cleanup.service'

@Component({
  selector: 'jml-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  sidebarDesktopInactive = false
  sidebarMobileActive = false
  profileMenuInactive = false

  constructor(
    public renderer: Renderer2,
    public authService: AuthService,
    public router: Router,
    private authFacade: AuthFacadeService,
    private dialogService: DialogService,
    private navSupportService: NavSupportService,
    private dialogCleanupService: DialogCleanupService
  ) {}

  ngOnInit() {}

  onMenuButtonClick(event): void {
    if (this.isDesktop()) {
      this.sidebarDesktopInactive = !this.sidebarDesktopInactive
    } else {
      this.sidebarMobileActive = !this.sidebarMobileActive
    }
  }

  onProfileButtonClick(event) {
    this.router.navigate(['/profile'])
  }

  onBuildInfoButtonClick(event) {
    this.dialogCleanupService.registerDialog(
      this.dialogService.open(BuildInfoDialogComponent, {
        header: 'Build Information',
        draggable: true
      })
    )
  }

  onLogoutButtonClick(event) {
    this.navSupportService.reset()
    this.authFacade.logout(true)

    this.router.navigate(['/login'])

    event.preventDefault()
  }

  isTablet() {
    const width = window.innerWidth
    return width <= 1024 && width > 640
  }

  isDesktop() {
    return window.innerWidth > 1024
  }

  isMobile() {
    return window.innerWidth <= 640
  }
}
